export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="hrGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F3E5AB" />
        <stop offset="1" stopColor="#D4AF37" />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="30" className="fill-[#0B1D16] stroke-[#D4AF37]/40" strokeWidth="1.5" />
    <path d="M12 42 Q32 21 52 42" stroke="url(#hrGold)" strokeWidth="3" strokeLinecap="round" />
    <path d="M32 18 C36.5 24 36.5 32 32 38.5 C27.5 32 27.5 24 32 18 Z" stroke="url(#hrGold)" strokeWidth="2.4" />
    <path d="M19.5 26.5 C24 29.5 26 34.5 25 40" stroke="url(#hrGold)" strokeWidth="2" strokeLinecap="round" />
    <path d="M44.5 26.5 C40 29.5 38 34.5 39 40" stroke="url(#hrGold)" strokeWidth="2" strokeLinecap="round" />
    <circle cx="32" cy="47.5" r="2.4" fill="url(#hrGold)" />
  </svg>
);

export const Logo = ({ compact = false, onClick }) => (
  <div
    onClick={onClick}
    data-testid="logo-hotel-raj"
    className={`flex items-center gap-3 ${onClick ? "cursor-pointer" : ""}`}
  >
    <LogoMark className="h-10 w-10 shrink-0" />
    {!compact && (
      <div className="leading-none">
        <div className="font-display text-base sm:text-lg tracking-[0.18em] text-[#FDFBF7]">
          HOTEL RAJ
        </div>
        <div className="mt-1 text-[9px] sm:text-[10px] tracking-[0.34em] text-[#D4AF37]/80 uppercase">
          East Champaran
        </div>
      </div>
    )}
  </div>
);

export default Logo;
